import React, { useEffect, useState } from 'react'

import { GlobalColorTag } from 'services/apiTypes/colorTag.types'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'
import { SET_DECK_STATE } from 'redux/deck/actions/types'

import ColorTagService from 'services/colorTag.service'
import ToastService from 'services/toast.service'

import Link from 'components/elements/Link'
import LineLoader from 'components/elements/LineLoader'
import ColorTagTable from 'components/misc/ColorTagTable'

import styles from './globalColorTags.module.scss'

const GlobalColorTags = () => {
  const globalColorTags = useAppSelector(state => state.active.globalColorTags)
  const deckColorTags = useAppSelector(state => state.deck.colorLabels)

  const [setActiveState, setDeckState] = useActionless(SET_ACTIVE_STATE, SET_DECK_STATE)

  const [loadingGlobalColorTags, setLoadingGlobalColorTags] = useState(true)

  const handleTagCreation = (tag: GlobalColorTag) =>
    setDeckState({ colorLabels: [...deckColorTags, { name: tag.name, color: tag.color }] })

  useEffect(() => {
    ColorTagService.list()
      .then(res => setActiveState({ globalColorTags: res }))
      .catch(() => ToastService.create('Unable to load global color tags', 'Deck page', 'error'))
      .finally(() => setLoadingGlobalColorTags(false))
  }, [])

  // Hide global tags that are already in the deck
  const visibleTags = (globalColorTags || []).filter(
    tag => !deckColorTags.some(deckTag => deckTag.name === tag.name && deckTag.color === tag.color),
  )

  return (
    <div>
      <h4>Color tag templates</h4>

      <p>
        You can manage your Color Tag Templates in your{' '}
        <Link className={styles.link} href="/accountSettings/color-tag-templates">
          Account Settings
        </Link>
        . To add these color tags to cards, use the color tag dropdown in the card options, or the corner quantity of a
        card.
      </p>

      {loadingGlobalColorTags && <LineLoader />}

      {globalColorTags !== null && visibleTags.length === 0 && (
        <div className={styles.none}>You have no unused color tag templates</div>
      )}

      {globalColorTags !== null && <ColorTagTable tags={visibleTags} onAddToDeck={handleTagCreation} />}
    </div>
  )
}

export default GlobalColorTags
